import { Trophy, MapPin, Globe } from "lucide-react";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import { Link } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";
import type { WinnerInfo } from "@/lib/events";

interface WinnerDisplayProps {
  winner: WinnerInfo | null;
  isLoading?: boolean;
}

export const WinnerDisplay = ({ winner, isLoading }: WinnerDisplayProps) => {
  if (isLoading) return <Skeleton className="h-4 w-24" />;
  if (!winner) return null;

  return (
    <span className="inline-flex items-center gap-1.5 text-sm">
      <Trophy className="h-3.5 w-3.5 text-amber-500 shrink-0" />
      {winner.onsite && (
        <span className="inline-flex items-center gap-0.5">
          <Tooltip>
            <TooltipTrigger asChild>
              <MapPin className="h-3 w-3 text-primary shrink-0" />
            </TooltipTrigger>
            <TooltipContent><p>Onsite winner</p></TooltipContent>
          </Tooltip>
          {winner.onsite.id ? (
            <Link
              to={`/participant/${winner.onsite.id}`}
              className="font-semibold text-primary hover:underline"
            >
              {winner.onsite.name}
            </Link>
          ) : (
            <span className="font-semibold text-foreground">{winner.onsite.name}</span>
          )}
        </span>
      )}
      {winner.onsite && winner.virtual && (
        <span className="text-muted-foreground/40 mx-0.5">|</span>
      )}
      {winner.virtual && (
        <span className="inline-flex items-center gap-0.5">
          <Tooltip>
            <TooltipTrigger asChild>
              <Globe className="h-3 w-3 text-muted-foreground shrink-0" />
            </TooltipTrigger>
            <TooltipContent><p>Virtual winner</p></TooltipContent>
          </Tooltip>
          {winner.virtual.id ? (
            <Link
              to={`/participant/${winner.virtual.id}`}
              className="text-primary hover:underline"
            >
              {winner.virtual.name}
            </Link>
          ) : (
            <span className="text-foreground">{winner.virtual.name}</span>
          )}
        </span>
      )}
    </span>
  );
};
